export const css = {
    root: '_3unVRfg5',
    ' _key': 'apic-theme/apic/variants/cic1'
};
export default css;
